<template>
	<div id="details_carryout" style="padding-bottom: 20px;">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>
		<van-form @submit="onSubmit">
			<van-field
				v-model="form.complete_remark"
				rows="3"
				autosize
				label="完成说明"
				type="textarea"
				placeholder="请输入完成说明"
				:rules="[
					{
						required: true,
						trigger: 'onBlur',
						message: '请输入完成说明',
					},
				]"
			/>
			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader
						v-model="form.uploader"
						:max-count="6"
						accept="all"
					/>
				</template>
			</van-field>

			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit"
					>提交</van-button
				>
			</div>
		</van-form>

		<van-overlay :show="!signTime">
			<div class="wrapper">
				<van-loading size="24px">文件上传中,请稍后...</van-loading>
			</div>
		</van-overlay>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { Toast } from "vant";
import axios from "axios";
import { getToken } from "@/utils/auth";

export default {
	name: "carryout_details",
	components: {
		navbar,
	},
	data() {
		return {
			title: "派单分配",
			form: {
				complete_remark: "",
				uploader: [],
			},
			signTime: true,
		};
	},
	methods: {
		onSubmit() {
			let that = this;
			let formData = new FormData();
			for (let i = 0; i < this.form.uploader.length; i++) {
				formData.append("file", this.form.uploader[i].file);
			}
			formData.append("complete_remark", this.form.complete_remark);
			formData.append("requestType", "open_event");
			formData.append("assign_id", this.$route.query.id);
			formData.append("assign_status", "3");
			formData.append("token", getToken());

			const config = {
				timeout: 60 * 1000,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			this.signTime = false;

			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then((res) => {
					console.log(res);
					if (res.data.code === 200) {
						this.$route.params.listRefresh = true;
						this.$router.go(-1);
						Toast.fail("确认成功完成!");
					} else if (res.data.code === 300) {
						this.$router.push({
							path: "/login",
						});
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				})
				.catch((err) => {
					console.log(err);
					that.signTime = true;
					let text = "当前网络环境差,请重新提交!";
					this.$toast.fail(text);
				});
		},
	},
};
</script>

<style lang="scss">
#details_carryout {
	.wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.van-loading__text {
		color: #ffffff;
	}
}
</style>
